export default __webpack_public_path__ + "static/custom-80d34d8eeaf7deed63ecbecc75ccbe01.webp";